import * as React from "react";
import {
  Grid,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Typography
} from "@material-ui/core";
import { ShowShareTable, IShareTableData } from "../table/ShareTable";

export interface IShareTableModalEntity {
  id: number;
  group: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IShareTableModalProps {
  title: string;
  table_01: IShareTableData[];
  table_02: IShareTableData[];
  showFirstTable?: boolean;
}

// tslint:disable-next-line:no-empty-interface
export interface IShareTableModalState {
  dialogOpen: boolean;
}

export class ShareTableModal extends React.Component<
  IShareTableModalProps,
  IShareTableModalState
> {
  constructor(props: IShareTableModalProps) {
    super(props);

    this.state = {
      dialogOpen: false
    };
  }

  public render() {
    if (this.props.showFirstTable) {
      return (
        <div>
          <div className="filter-item">
            <Button onClick={this.handleDialogOpen} color="primary">
              Ver Mais
            </Button>
            <Dialog
              fullScreen={true}
              open={this.state.dialogOpen}
              onClose={this.handleDialogClose}
              aria-labelledby="share-table-modal-group-dialog-title"
              aria-describedby="share-table-modal-group-dialog-description"
              className="share-table-modal-dialog"
            >
              <DialogTitle
                className="share-table-modal-dialog-title"
                id="share-table-modal-group-dialog-title"
              >
                {this.props.title}
              </DialogTitle>
              <DialogContent className="share-table-modal-dialog-content">
                <Paper className="shared-share-sharetablemodal-block panel-block">
                  <Grid container={true} spacing={16}>

                      <Typography
                        variant="headline"
                        className="table-title"
                        component="title"
                      >
                        {this.props.title === '' ? 'SHARE POR LOJA' : ''}
                      </Typography>
                      {this.props.table_01 && (
                        <ShowShareTable data={this.props.table_01} />
                      )}
                    
                  </Grid>
                </Paper>
              </DialogContent>
              <DialogActions className="share-table-modal-actions">
                <Button
                  className="filter-dialog-close"
                  onClick={this.handleDialogClose}
                >
                  Fechar
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="filter-item">
            <Button onClick={this.handleDialogOpen} color="primary">
              Ver Mais
            </Button>
            <Dialog
              fullScreen={true}
              open={this.state.dialogOpen}
              onClose={this.handleDialogClose}
              aria-labelledby="share-table-modal-group-dialog-title"
              aria-describedby="share-table-modal-group-dialog-description"
              className="share-table-modal-dialog"
            >
              <DialogTitle
                className="share-table-modal-dialog-title"
                id="share-table-modal-group-dialog-title"
              >
                {this.props.title}
              </DialogTitle>
              <DialogContent className="share-table-modal-dialog-content">
                <Paper className="shared-share-sharetablemodal-block panel-block">
                  <Grid container={true} spacing={16}>
                    <Grid item={true} lg={6} xs={12} sm={12}>
                      <Typography
                        variant="headline"
                        className="table-title"
                        component="title"
                      >
                        SHARE POR LOJA
                      </Typography>
                      {this.props.table_01 && (
                        <ShowShareTable data={this.props.table_01} />
                      )}
                    </Grid>
                    <Grid item={true} lg={6} xs={12} sm={12}>
                      <Typography
                        variant="headline"
                        className="panel-title"
                        component="title"
                      >
                        SHARE LOJA (MERCADO)
                      </Typography>
                      {this.props.table_02 && (
                        <ShowShareTable data={this.props.table_02} />
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </DialogContent>
              <DialogActions className="share-table-modal-actions">
                <Button
                  className="filter-dialog-close"
                  onClick={this.handleDialogClose}
                >
                  Fechar
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        </div>
      );
    }
  }

  private handleDialogOpen = () => {
    this.setState({ dialogOpen: true });
  };

  private handleDialogClose = () => {
    this.setState({ dialogOpen: false });
  };
}



// WEBPACK FOOTER //
// ./src/component/shared/share/modal/ShareTableModal.tsx